import * as t from 'ts-codec';
import { date, ObjectId, ResourceId } from '@journeyapps-labs/micro-codecs';
export var AuthCodes;
(function (AuthCodes) {
    AuthCodes["USER_EXISTS"] = "USER_EXISTS";
    AuthCodes["INVALID_DOB"] = "INVALID_DOB";
    AuthCodes["PROFILE_IN_USE"] = "PROFILE_IN_USE";
    AuthCodes["INVALID_PASSWORD"] = "INVALID_PASSWORD";
    AuthCodes["INVALID_RESET_CODE"] = "INVALID_PASSWORD_RESET_CODE";
    AuthCodes["INVALID_PROFILE"] = "INVALID_PROFILE";
    AuthCodes["REGISTRATION_DISABLED"] = "REGISTRATION_DISABLED";
    AuthCodes["UNKNOWN_ACCOUNT"] = "UNKNOWN_ACCOUNT";
    AuthCodes["MAINTENANCE_MODE"] = "MAINTENANCE_MODE";
    AuthCodes["NO_MORE_CODES_ALLOWED"] = "NO_MORE_CODES_ALLOWED";
})(AuthCodes || (AuthCodes = {}));
export var AuthRoutes;
(function (AuthRoutes) {
    AuthRoutes["REGISTER"] = "/api/v1/register";
    AuthRoutes["REGISTER_CODE_GENERATE"] = "/api/v1/register-code-generate";
    AuthRoutes["REGISTER_CODE_LIST"] = "/api/v1/register-code-list";
    AuthRoutes["LOGIN"] = "/api/v1/login";
    AuthRoutes["FORGOT_PASSWORD"] = "/api/v1/forgot-password";
    AuthRoutes["RESET_PASSWORD"] = "/api/v1/reset-password";
    AuthRoutes["TOKEN"] = "/api/v1/token";
})(AuthRoutes || (AuthRoutes = {}));
export const ResetPasswordRequest = t.object({
    code: t.string,
    password: t.string
});
export const SharedProfileRequest = t.object({
    profile_name: t.string
});
export var AccountProfileRelationship;
(function (AccountProfileRelationship) {
    AccountProfileRelationship["OWNER"] = "owner";
})(AccountProfileRelationship || (AccountProfileRelationship = {}));
export const TokenResponse = t.object({
    token: t.string
});
export const AccessTokenResponse = t.object({
    token: t.string,
    refresh_token: t.string
});
export const AccountProfile = ResourceId.and(t.object({
    association: t.Enum(AccountProfileRelationship)
}));
export const RegisterCode = ResourceId.and(t.object({
    code: t.string,
    used: t.boolean
}));
//!----------- REGISTER_CODE_LIST -----------
export const RegisterCodeListResponse = t.array(RegisterCode);
//!----------- REGISTER -----------
export const RegisterRequest = t.object({
    password: t.string,
    email: t.string,
    profile: t.string,
    code: t.string.optional(),
    dob: date
});
//!----------- LOGIN -----------
export const LoginRequest = t.object({
    email: t.string,
    password: t.string
});
export const LoginResponse = TokenResponse.and(t.object({
    profiles: t.array(ObjectId)
}));
export const AccessTokenRequest = t.object({
    profile_id: ObjectId
});
//!----------- FORGOT PASSWORD -----------
export const ForgotPasswordRequest = t.object({
    email: t.string
});
